import ReportComment from '@/components/reports/ReportComment'
import Subsection from '@/components/reports/Subsection'

export default {
  props: ['model'],
  components: {
    ReportComment,
    Subsection,
  },
  computed: {
    removed: function() {
      return this.$parent.removedSections[this.stepName].removed
    },
    seasonStartYear: function() {
      return this.$parent.model.Misc['season_start_year']
    },
    stepName: function() {
      return this.$options.name
    },
  },
  methods: {
    isRemovedSubsection: function(subsection) {
      return this.$parent.removedSections[this.stepName][subsection]
    },
    getRowClass: function(items, key, index) {
      if (index == 0) {
        this.lastRowClass = 'colored-table-row'
        return 'colored-table-row'
      }
      let lastItemSeason = this.getRowSeason(items[index - 1][key])
      let currentItemSeason = this.getRowSeason(items[index][key])

      if (lastItemSeason != currentItemSeason) {
        if (this.lastRowClass == 'colored-table-row') {
          this.lastRowClass = ''
        } else {
          this.lastRowClass = 'colored-table-row'
        }
      }
      return this.lastRowClass
    },
    getRowSeason: function(str) {
      return str.substring(str.length - 4)
    },
  },
}
